export default __webpack_public_path__ + "static/media/github.18502f05.svg";